@let sourcesSectionId = 'ai-shared-model-message-sources-' + message().id;

<section class="w-full">
    <span class="sr-only">
        @if (senderName(); as name) {
            {{ 'AI.ACCESSIBILITY.MESSAGE_FROM_AGENT' | translate: { name } }}
        } @else {
            {{ 'AI.ACCESSIBILITY.MESSAGE_FROM_AI' | translate }}
        }
    </span>
    <ng-content select="[aiSharedBeforeMessage]" />
    @if (displayDelta(); as messageDelta) {
        <interacta-delta-view class="block typo-sm" [delta]="messageDelta" />
        @if (popoverOrigin(); as origin) {
            @let popoverTitle =
                popoverSources().length === 1
                    ? ('AI.SOURCE' | translate)
                    : ('AI.SOURCES_COUNT'
                      | translate: { count: popoverSources().length });
            <interacta-menu-dialog
                [ariaLabel]="popoverTitle"
                [open]="true"
                [origin]="origin"
                (closing)="closeReferencePopover()"
            >
                <!-- Four cards fit before scrolling: 18px title + 8px gap + 4 * 72px + 3 * 8px gap + 16px padding. -->
                <div
                    class="max-h-354 p-8"
                    interactaMenuDecorator
                    [fixedWidth]="320"
                >
                    <h2 class="mb-8 typo-xs-bold text-text-mid-contrast">
                        {{ popoverTitle }}
                    </h2>
                    <interacta-ai-shared-references
                        [origin]="'inline'"
                        [references]="popoverSources()"
                        [smartActionsDisabled]="smartActionsDisabled()"
                        (askReference)="onPopoverAskReference($event)"
                        (referenceOpened)="closeReferencePopover()"
                        (smartAction)="onPopoverSmartAction($event)"
                    />
                </div>
            </interacta-menu-dialog>
        }
    } @else {
        <p class="typo-sm wrap-break-word" [innerHtml]="displayedMessage()"></p>
    }
    @if (contentRevealed()) {
        <div [class.ai-delta-footer]="animateDelta()">
            <div class="mt-8 flex items-center justify-between">
                <div class="flex gap-x-8">
                    @if (!isError()) {
                        @let likeButtonLabel = 'AI.LIKE' | translate;
                        <button
                            interacta-toggle-icon-button
                            type="button"
                            [disabled]="!canSendFeedback()"
                            [icon]="'thumb-up'"
                            [label]="likeButtonLabel"
                            [selected]="message().feedbackLike === true"
                            (click)="
                                sendFeedbackLike.emit(
                                    message().feedbackLike === true
                                        ? undefined
                                        : true
                                )
                            "
                        ></button>
                        @let dislikeButtonLabel = 'AI.DISLIKE' | translate;
                        <button
                            interacta-toggle-icon-button
                            type="button"
                            [disabled]="!canSendFeedback()"
                            [icon]="'thumb-down'"
                            [label]="dislikeButtonLabel"
                            [selected]="message().feedbackLike === false"
                            (click)="
                                sendFeedbackLike.emit(
                                    message().feedbackLike === false
                                        ? undefined
                                        : false
                                )
                            "
                        ></button>
                        <button
                            interacta-icon-button
                            type="button"
                            [icon]="'copy'"
                            [label]="'AI.COPY' | translate"
                            [size]="'regular'"
                            [style]="'text'"
                            (click)="copyText()"
                        ></button>
                    } @else if (!hideRetryButton()) {
                        <button
                            interacta-button
                            type="button"
                            [icon]="'retry'"
                            [label]="'SHARED.BUTTON.RETRY' | translate"
                            [style]="'text'"
                            (click)="retry.emit()"
                        ></button>
                    }
                </div>
                @if (message().references.length) {
                    <button
                        class="typo-xs-bold"
                        interacta-button
                        type="button"
                        [attr.aria-controls]="sourcesSectionId"
                        [attr.aria-expanded]="showReferences()"
                        [icon]="
                            showReferences()
                                ? 'chevron-small-up'
                                : 'chevron-small-down'
                        "
                        [label]="'AI.SOURCES' | translate"
                        (click)="toggleReferences()"
                    ></button>
                }
            </div>
            @if (message().references.length && showReferences()) {
                <div
                    animate.enter="animate-collapse-in"
                    animate.leave="animate-collapse-out"
                    class="mt-16 mb-8 grid motion-reduce:animate-none"
                >
                    <interacta-ai-shared-references
                        class="block overflow-hidden"
                        [id]="sourcesSectionId"
                        [references]="message().references"
                        [smartActionsDisabled]="smartActionsDisabled()"
                        (askReference)="askReference.emit($event)"
                        (smartAction)="smartAction.emit($event)"
                    />
                </div>
            }

            <interacta-ai-feedback
                [like]="message().feedbackLike"
                [thanksSurface]="'surface-B'"
                (sendFeedbackDetail)="sendFeedbackDetail.emit($event)"
            />

            @if (isLast() && !isError()) {
                <p class="w-full pt-8 typo-xs text-text-mid-contrast">
                    {{ 'AI.DISCLAIMER' | translate }}
                </p>
            }
        </div>
    }
</section>
